import React, { useState } from "react";
import { GenericCheckbox } from "../../ui-components/Checkbox/GenericCheckbox";

const CheckboxPlayground = ({ theme }: { theme: "light" | "dark" }) => {
  const [checkboxChecked, setCheckboxChecked] = useState(false);

  return (
    <section id="checkbox" className="mb-10">
      <h2 className="text-2xl font-semibold mb-4">Checkbox</h2>
      <GenericCheckbox
        label="I accept terms and conditions"
        checked={checkboxChecked}
        onChange={setCheckboxChecked}
        theme={theme}
        size="md"
      />
      <p>Checkbox is {checkboxChecked ? "checked" : "unchecked"}</p>
    </section>
  );
};

export default CheckboxPlayground;
